import React, {useRef} from 'react';
import ReactModal from 'react-modal';
import SilverButton from '../../buttons/SilverButton';
import BlueButton from '../../buttons/BlueButton';
import XIcon from '../../../assets/icons/XIcon';
import Translate from '../../../components/Translate';
import './styles.css';

/* `footer={null}` keeps existing dialogs' own actions while they migrate to
   the shared shell. New dialogs receive Cancel and Confirm automatically. */
const Modal = ({
                   header,
                   title = null,
                   description = null,
                   headerIcon = null,
                   headerSeparator = false,
                   footer,
                   footerSeparator = false,
                   allowContentOverflow = false,
                   children,
                   onSubmit,
                   onCancel,
                   onRequestClose,
                   style = {},
                   className = '',
                   modalClassName = '',
                   ...rest
               }) => {
    const cancel = onCancel || onRequestClose;
    const overlayMouseDownRef = useRef(false);
    const contentStyle = style.content || {};
    const contentClasses = [
        'app-modal__content',
        !headerSeparator && 'app-modal__content--compact-top',
        footer !== null && !footerSeparator && 'app-modal__content--compact-bottom',
        allowContentOverflow && 'app-modal__content--overflow-visible',
    ].filter(Boolean).join(' ');

    /* react-modal 3.5.1 can retain shouldClose=false after a click inside the
       modal opens another portal (for example, a Drawer). The first overlay
       click after that only clears its stale flag. Track each interaction
       locally instead, while preserving the protection against drags that
       begin in the modal content and end on the overlay. */
    const renderOverlay = (overlayProps, contentElement) => (
        <div
            {...overlayProps}
            onMouseDown={(event) => {
                overlayMouseDownRef.current = event.target === event.currentTarget;
            }}
            onMouseUp={(event) => {
                if (event.target !== event.currentTarget) overlayMouseDownRef.current = false;
            }}
            onTouchStart={(event) => {
                overlayMouseDownRef.current = event.target === event.currentTarget;
            }}
            onTouchEnd={(event) => {
                if (event.target !== event.currentTarget) overlayMouseDownRef.current = false;
            }}
            onClick={(event) => {
                const startedOnOverlay = overlayMouseDownRef.current;
                overlayMouseDownRef.current = false;

                if (startedOnOverlay && event.target === event.currentTarget && cancel) {
                    cancel(event);
                }
            }}
        >
            {contentElement}
        </div>
    );

    return (
        <ReactModal
            {...rest}
            onRequestClose={cancel}
            shouldCloseOnOverlayClick={false}
            overlayElement={renderOverlay}
            style={{
                ...style,
                content: {
                    ...contentStyle,
                    padding: 0,
                    borderRadius: 16,
                    backgroundColor: 'var(--ds-bg-primary)',
                    maxWidth: contentStyle.maxWidth || 'calc(100vw - 32px)',
                    maxHeight: contentStyle.maxHeight || 'calc(100vh - 32px)',
                    ...(allowContentOverflow ? {overflow: 'visible'} : {}),
                },
            }}
            className={className || undefined}
        >
            <div className={`app-modal ${modalClassName}`.trim()}
                 style={{height: contentStyle.height ? '100%' : 'auto'}}>
                <header className={`app-modal__header ${headerSeparator ? 'separator' : ''}`}>
                    <div className="app-modal__header-content">{
                        header ? header :
                            <div style={{display: 'flex', alignItems: 'center', gap: '16px'}}>
                                {headerIcon && <div className="app-modal__header-icon">{headerIcon}</div>}
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '2px'
                                }}>
                                 <span style={{fontSize: '16px', fontWeight: 600, color: 'var(--ds-text-primary)'}}>
                                    {title}
                                </span>
                                    <span style={{fontSize: '14px', fontWeight: 400, color: 'var(--ds-text-tertiary)'}}>
                                    {description}
                                </span>
                                </div>
                            </div>

                    }</div>
                    <SilverButton
                        type="button"
                        variant="ghost"
                        width="20px"
                        height="20px"
                        iconOnly
                        expandedHover
                        styles={{padding: 0, flexShrink: 0}}
                        onClick={cancel || (() => {
                        })}
                        disabled={!cancel}
                    >
                        <XIcon width={20} height={20} stroke="var(--ds-fg-quaternary-400)"/>
                    </SilverButton>
                </header>
                <div className={contentClasses}>
                    {children}
                </div>
                {footer !== null && (
                    <footer className={`app-modal__footer ${footerSeparator ? 'separator' : ''}`}>
                        {footer === undefined ? (
                            <React.Fragment>
                                <SilverButton type="button" width="auto" height="40px" onClick={cancel || (() => {
                                })}>
                                    <Translate text="cancel"/>
                                </SilverButton>
                                <BlueButton type="button" width="auto" height="40px" onClick={onSubmit || (() => {
                                })}>
                                    <Translate text="confirm"/>
                                </BlueButton>
                            </React.Fragment>
                        ) : footer}
                    </footer>
                )}
            </div>
        </ReactModal>
    );
};

Modal.setAppElement = ReactModal.setAppElement;

export default Modal;



// WEBPACK FOOTER //
// ./src/components-new/ui/Modal/index.jsx